"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

require("./DropdownMenu.less");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NOOP = function NOOP() {};

var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(DropdownMenu, _React$Component);

  var _super = _createSuper(DropdownMenu);

  function DropdownMenu() {
    (0, _classCallCheck2.default)(this, DropdownMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DropdownMenu, [{
    key: "getItemsAndActiveIndex",
    value: function getItemsAndActiveIndex() {
      return this.menu.getItemsAndActiveIndex();
    }
  }, {
    key: "getFocusableMenuItems",
    value: function getFocusableMenuItems() {
      return this.menu.getFocusableMenuItems();
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      return this.menu.focusNext();
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      return this.menu.focusPrevious();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          open = _this$props.open,
          hasTitle = _this$props.hasTitle,
          labelledBy = _this$props.labelledBy,
          bsClass = _this$props.bsClass,
          onClose = _this$props.onClose,
          onSelect = _this$props.onSelect,
          children = _this$props.children;
      var ulProps = Object.assign({}, this.props);
      delete ulProps.children;
      delete ulProps.open;
      delete ulProps.hasTitle;
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, (0, _extends2.default)({
        ref: function ref(menu) {
          return _this.menu = menu;
        }
      }, ulProps, {
        className: "primitive-dropdown-menu dropdown-menu ".concat(hasTitle ? 'has-title' : '', " ").concat(open ? 'open' : ''),
        labelledBy: labelledBy,
        bsClass: bsClass,
        onClose: onClose,
        onSelect: onSelect,
        open: open,
        hasTitle: hasTitle
      }), children);
    }
  }], [{
    key: "Dropdown",
    get: function get() {
      return _reactBootstrap.Dropdown;
    }
  }, {
    key: "Toggle",
    get: function get() {
      return _reactBootstrap.Dropdown.Toggle;
    }
  }, {
    key: "MenuItem",
    get: function get() {
      return _reactBootstrap.MenuItem;
    }
  }, {
    key: "propTypes",
    get: function get() {
      return _objectSpread(_objectSpread({}, _reactBootstrap.Dropdown.Menu.propTypes), {}, {
        open: _propTypes.default.bool,
        hasTitle: _propTypes.default.bool
      });
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        bsRole: 'menu',
        onClose: NOOP,
        onSelect: NOOP
      };
    }
  }]);
  return DropdownMenu;
}(_react.default.Component);

exports.default = DropdownMenu;